import React from "react";
import DashboardHome from "../DashboardHome";
import { indiaOperations } from "../../utils/indiaOperationsSource";

/** India "Dashboard" page: the Australian overview on India data (₹). */
const IndiaDashboardHome = () => <DashboardHome source={indiaOperations} />;

export default IndiaDashboardHome;
